import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import queryString from 'query-string';

import PostcoderAddress from 'models/PostcoderAddressModel';

import { Logger } from 'utils/Logger';

import {
  requestPostcoderAddressFailure,
  requestPostcoderAddressSuccess,
  requestPostcoderSearchFailure,
  requestPostcoderSearchSuccess,
} from './actions';

import { postcoderAddress, postcoderSearch } from './types';

const logger = new Logger('Saga:Postcoder');
const baseUrl = 'https://ws.postcoder.com/pcw/autocomplete/';

const buildUrl = (type, options) =>
  `${baseUrl}${type}?${queryString.stringify({
    apikey: window._env_.POSTCODER_API_KEY,
    country: 'UK',
    identifier: window._env_.RUNNING_ENV === 'production' ? 'prod' : 'dev',
    ...options,
  })}`;

export function* requestPostcoderSearchSaga(action) {
  const authApiService = yield getContext('authApiService');

  try {
    const response = yield call(
      authApiService.get,
      buildUrl('find', {
        maximumresults: 5,
        query: action.term,
        ...(action.filter ? { pathFilter: action.filter } : {}),
      }),
    );

    yield put(requestPostcoderSearchSuccess(response.data));
  } catch (error) {
    logger.error('Failed to search Postcoder client', error);
    yield put(requestPostcoderSearchFailure());
  }
}

export function* requestPostcoderAddressSaga(action) {
  const authApiService = yield getContext('authApiService');

  try {
    const response = yield call(
      authApiService.get,
      buildUrl('retrieve', {
        id: action.id,
        include: 'addressline',
        lines: 1,
        query: action.term,
        ...(action.filter ? { pathFilter: action.filter } : {}),
      }),
    );

    yield put(requestPostcoderAddressSuccess());
    action.promise && action.promise.resolve(PostcoderAddress.deserialize(response.data?.[0]));
  } catch (error) {
    logger.error('Failed to request Postcoder Address client', error);
    yield put(requestPostcoderAddressFailure());
    action.promise && action.promise.reject(error);
  }
}

export default function* requestHelpSaga() {
  return yield all([
    takeLatest(postcoderAddress.request, requestPostcoderAddressSaga),
    takeLatest(postcoderSearch.request, requestPostcoderSearchSaga),
  ]);
}
